window.preventDefaultFunction = (event) => {
    event.preventDefault();
};